(function() {
  'use strict';

  angular.module('blocks.auth', []);
})();
